<!-- <div class="main-wrapper">
    <app-header></app-header>
    <div class="app-body position-relative">
       <app-sidebar></app-sidebar>
        <main class="main" *ngIf="firstDataLength != 0">
            <div class="row">
                <div class="col-md-12">
                    <div class="game-highlight-wrap">
                        <div class="game-menu-tab">
                            <div class="tab-content" id="pills-tabContent" *ngIf="dataLength != 0">
                                <div class="tab-pane fade show active" id="pills-1" role="tabpanel" aria-labelledby="pills-1-tab" tabindex="0">
                                    <table class="table table-hover">
                                        <thead>
                                            <th class="view-mobile" colspan="2"></th>
                                            <th class="text-center">1</th>
                                            <th class="text-center">X</th>
                                            <th class="text-center">2</th>
                                            <th class="text-center"></th>
                                        </thead>  
                                        <tbody *ngFor="let matchData of homeData;let i = index;">
                                            <tr>
                                                <td (click)="matchDetail(matchData)">
                                                    <a class="match-name"><span>{{matchData?.match_name}}</span></a>
                                                    <span class="in_play" *ngIf="matchData?.inplay == true || matchData?.manualInplay == true">In-Play</span>
                                                    <p class="match-time" *ngIf="matchData?.inplay != true || matchData?.manualInplay != true">{{(matchData?.match_date |  date :'dd-MM-yyyy HH:mm')}}</p>
                                                </td>
                                                <td class="game-market">
                                                    <span class="game-fancy" *ngIf="matchData?.enable_fancy == 1">F</span>
                                                    <span class="game-sportbook">S</span>
                                                </td>
                                                <td class="count">
                                                    <span class="back">{{ matchData?.runners[0] == undefined ||matchData?.runners[0].ex?.availableToBack[0]?.price == undefined ? 0 :
                                                        matchData?.runners[0]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay">{{matchData?.runners[0]?.ex?.availableToLay[0]?.price
                                                        == undefined ? 0 :
                                                        matchData?.runners[0]?.ex?.availableToLay[0]?.price}}</span>
                                                </td>
                                                <td class="count">
                                                    <span class="back"> {{matchData?.runners[2] == undefined || (matchData?.runners[2]?.ex?.availableToBack).length != 0 ? '--' :
                                                        matchData?.runners[2]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay"> {{matchData?.runners[2] == undefined || (matchData?.runners[2]?.ex?.availableToLay).length != 0 ? '--' :
                                                        matchData?.runners[2]?.ex?.availableToLay[0]?.price}}</span>
                                                </td>
                                                <td class="count position-relative">
                                                    <span class="back"> {{matchData?.runners[1] == undefined ||matchData?.runners[1]?.ex?.availableToBack[0]?.price
                                                        == undefined ? 0 :
                                                        matchData?.runners[1]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay">{{matchData?.runners[1]?.ex?.availableToLay[0]?.price ==undefined ? 0 :
                                                        matchData?.runners[1]?.ex?.availableToLay[0]?.price}}</span>
                                                        <div class="spnd-fncy medium" *ngIf="matchData?.status == 'SUSPENDED'"><span class="stats-text">Suspended</span></div>
                                                </td>
                                            </tr>
                                        </tbody>  
                                    </table>
                                </div>
                            </div>                                                                                    
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <main class="main" *ngIf="firstDataLength == 0">
            <div class="row">
              <div class="col-md-12 multimarket">
                <div class="main-wrap">
                  <div class="no-data">
                    <h3>There are currently no followed multi markets.</h3>
                    <p>Please add some markets from events.</p>
                  </div>
                </div>
              </div>  
            </div>
        </main>
        <app-right-sidebar></app-right-sidebar>              
    </div>
   <app-footer-main></app-footer-main>
</div> -->


<div class="wrapper">
    <app-header></app-header>
    <div class="main">
        <div class="container-fluid container-fluid-5">
            <div class="row row5">
                <div class="sidebar col-md-2 hide-small">
                    <app-sidebar></app-sidebar>
                </div>
                <div class="col-12 hide-large featured-box">
                    <ul class="nav nav-tabs sport-tab">
                        <li class="nav-item"><a class="nav-link" (click)="goToAll('All')">Home</a></li>
                        <li class="nav-item"><a class="nav-link" (click)="inplay()">In-Play</a></li>
                        <li class="nav-item"><a class="nav-link active" (click)="multi()">Multi Markets</a></li>
                        <!-- <li class="nav-item" *ngFor="let sports of allSportsList;let i= index"
                          (click)="goToDashboard(sports.name,sports.sport_id,sports)"><a class="nav-link"
                            [ngClass]="{'newlaunch':sports.sport_id <= -100 }">{{sports.name}}</a></li> -->
                    </ul>
                </div>

                <div class="col-md-10 featured-box">
                    <div>
                        <div class="pb-4">
                            <div class="coupon-card coupon-card-first" *ngIf="firstDataLength != 0">
                                <div class="card-content" *ngIf="dataLength != 0">
                                    <table class="table coupon-table mobile-coupon-table">
                                        <thead>
                                            <tr>
                                                <th style="width: 63%;">Game</th> 
                                                <th colspan="2">1</th> 
                                                <th colspan="2">X</th> 
                                                <th colspan="2">2</th>
                                            </tr>
                                        </thead>
                                         
                                        <tbody *ngFor="let matchData of homeData;let i = index;">
                                            <tr>
                                                <td (click)="matchDetail(matchData)">
                                                    <div class="game-name">
                                                        <a class="text-dark">
                                                            <span>{{matchData?.match_name}}</span>
                                                            <span *ngIf="matchData?.inplay != true || matchData?.manualInplay != true">{{(matchData?.match_date |  date :'dd-MM-yyyy HH:mm')}}</span>
                                                        </a>
                                                    </div>
                                                    <div class="game-icons">
                                                        <span class="game-icon inplay" *ngIf="matchData?.inplay == true || matchData?.manualInplay == true">
                                                            <span class="active"></span>
                                                        </span>
                                                        <span class="game-icon" *ngIf="(matchData?.match_tv_url != null || matchData?.match_tv_url != undefined) && (matchData?.inplay == true )"><i class="fa fa-tv v-m icon-tv"></i></span>
                                                        <span class="game-icon" *ngIf="matchData?.enable_fancy == 1"><img src="assets/diamond_img/ic_fancy.png" class="fancy-icon"></span>
                                                        <span class="game-icon"><img src="assets/diamond_img/ic_bm.png" class="bookmaker-icon"></span>
                                                        <span class="game-icon"><img src="assets/diamond_img/ic_vir.png" class="ic-card"></span>
                                                    </div>
                                                </td>
                                                <td class="count">
                                                    <span class="back">{{ matchData?.runners[0] == undefined ||matchData?.runners[0].ex?.availableToBack[0]?.price == undefined ? 0 :
                                                        matchData?.runners[0]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay">{{matchData?.runners[0]?.ex?.availableToLay[0]?.price
                                                        == undefined ? 0 :
                                                        matchData?.runners[0]?.ex?.availableToLay[0]?.price}}</span>
                                                </td>
                                                <td class="count">
                                                    <span class="back"> {{matchData?.runners[2] == undefined || (matchData?.runners[2]?.ex?.availableToBack).length != 0 ? '--' :
                                                        matchData?.runners[2]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay"> {{matchData?.runners[2] == undefined || (matchData?.runners[2]?.ex?.availableToLay).length != 0 ? '--' :
                                                        matchData?.runners[2]?.ex?.availableToLay[0]?.price}}</span>
                                                </td>
                                                <td class="count position-relative">
                                                    <span class="back"> {{matchData?.runners[1] == undefined ||matchData?.runners[1]?.ex?.availableToBack[0]?.price
                                                        == undefined ? 0 :
                                                        matchData?.runners[1]?.ex?.availableToBack[0]?.price}}</span>
                                                    <span class="lay">{{matchData?.runners[1]?.ex?.availableToLay[0]?.price ==undefined ? 0 :
                                                        matchData?.runners[1]?.ex?.availableToLay[0]?.price}}</span>
                                                </td>
                                            </tr>
                                        </tbody>  
                                    </table>
                                </div>
                            </div>
                            <div class="coupon-card coupon-card-first" *ngIf="firstDataLength == 0">
                                <div class="card-content">
                                    <div class="no-data">
                                        <h3>There are currently no followed multi markets.</h3>
                                        <p>Please add some markets from events.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-main></app-footer-main>